export default __webpack_public_path__ + "static/media/Professional Profile.298a0f18.jpg";